const CampaignSummaryParser = (data: any): any => {
  const retData = [
    {
      id: '1',
      label: 'Total Campaigns',
      value: data?.distributionCount ?? '0',
      tooltip: 'Total campaigns that are in selected date range.',
    },
    {
      id: '2',
      label: 'Active Campaigns',
      value: data?.activeCampaigns ?? '0',
      tooltip: 'Total campaigns that are currently active in selected date range.',
    },
    {
      id: '3',
      label: 'Amount of Rewards Distributed',
      value: `₹ ${Number(data?.rewardsDistributed)?.toFixed(2) ?? 0}`,
      tooltip: 'Offers availed by customers vs. budgeted by you across all campaigns.',
    },
  ]
  return retData
}

export { CampaignSummaryParser }
